import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import api from '../api/client.js';

// Contact "method" = the touch_type of the most recent note logged against the
// customer. Mirrors the values the AI note service assigns.
const METHOD = {
  visit: { label: 'Visit', icon: '🚗' },
  call:  { label: 'Call',  icon: '📞' },
  email: { label: 'Email', icon: '✉' },
  text:  { label: 'Text',  icon: '💬' },
  phone: { label: 'Phone', icon: '📞' },
  quote: { label: 'Quote', icon: '📄' },
  note:  { label: 'Note',  icon: '📝' },
  other: { label: 'Other', icon: '•' },
};

function methodOf(t) {
  return (t && METHOD[t]) || { label: 'No contact', icon: '—' };
}

export default function StaleInventory() {
  const [days, setDays] = useState(30);

  const list = useQuery({
    queryKey: ['stale-inventory', days],
    queryFn: () => api.get('/customers/due-for-visit', { params: { days } }).then(r => r.data.data),
  });

  return (
    <div className="space-y-4">
      <header>
        <div className="section-eyebrow">Inventory</div>
        <h1 className="text-2xl">Stale inventory</h1>
        <div className="rule-crimson" />
        <p className="text-xs text-muted mt-1">
          Accounts in your scope with no contact in the selected window — last contact date and method shown.
        </p>
      </header>

      <div className="card p-3 grid grid-cols-2 sm:grid-cols-4 gap-2 items-end">
        <div>
          <label className="label">No contact for ≥ days</label>
          <select className="input" value={days} onChange={e => setDays(parseInt(e.target.value, 10))}>
            <option value={7}>7</option>
            <option value={14}>14</option>
            <option value={30}>30</option>
            <option value={60}>60</option>
            <option value={90}>90</option>
            <option value={180}>180</option>
          </select>
        </div>
        <div className="sm:col-span-2" />
        <div className="text-right text-sm text-muted self-center">
          {list.data?.length || 0} accounts
        </div>
      </div>

      <div className="space-y-1">
        {list.isLoading && <div className="text-muted">Loading…</div>}
        {list.data?.length === 0 && <div className="text-muted">All caught up at this threshold.</div>}
        {list.data?.map(c => {
          const m = methodOf(c.last_touch_type);
          return (
            <Link key={c.id} to={`/customers/${c.id}`}
                  className="card p-3 flex items-baseline justify-between hover:ring-1 hover:ring-crimson">
              <div>
                <div className="font-medium">{c.name}</div>
                <div className="text-xs text-muted">
                  {[c.city, c.state].filter(Boolean).join(', ') || '—'}
                  {c.phone && <> · 📞 {c.phone}</>}
                </div>
              </div>
              <div className="text-right text-sm">
                <div className={c.days_since_touch > 90 ? 'text-crimson font-semibold' : 'text-navy'}>
                  {c.days_since_touch}d since contact
                </div>
                <div className="text-xs text-muted">
                  {m.icon} {m.label}
                  {c.last_at && <> · {new Date(c.last_at).toLocaleDateString()}</>}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
